import { createFileRoute, redirect } from '@tanstack/react-router';

import { ensureSession } from '@/features/auth/api';

/** "/" only decides where to go: the org overview when signed in, otherwise sign-in. */
export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    const s = await ensureSession();
    if (s.user?.email_verified) throw redirect({ to: '/overview' });
    if (s.user) throw redirect({ to: '/verify-email', state: { email: s.user.email } });
    throw redirect({ to: '/sign-in' });
  },
  component: () => null,
});
